import { render } from "./StatisticsClientsView.vue?vue&type=template&id=723c8d17&scoped=true"
import script from "./StatisticsClientsView.vue?vue&type=script&lang=js"
export * from "./StatisticsClientsView.vue?vue&type=script&lang=js"

import "./StatisticsClientsView.vue?vue&type=style&index=0&id=723c8d17&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723c8d17"]])

export default __exports__